"use strict";
import request from "@/utils/request";
const config = require("@/../config/config.json");
import logger from "@/utils/logger";

export async function svc_addStock(data) {
	return request(`${config.apiUrl}inventory/stock`, {
    method: "POST",
    data: data,
	});
}

export async function svc_getTotals(data) {
	return request(`${config.apiUrl}inventory/stock/totals/`, {
		method: "GET",
		params: data,
	});
}